<template>
  <!--
    Deepest-level row in the grouped PMA view. Lives inside the
    fixed-layout <table> in PMAMakeRow — cell widths come from the
    colgroup there. Truncated cells expose full text via title= so
    users can hover for the unabbreviated value without us having to
    wrap long lines into the row.
  -->
  <tr class="hover:bg-gray-50 align-top">
    <td class="px-3 py-1 truncate text-black" :title="approval.model">
      {{ approval.model }}
    </td>
    <td class="px-3 py-1 truncate text-black" :title="approval.part_name">
      {{ approval.part_name }}
    </td>
    <td class="px-3 py-1 text-black whitespace-nowrap">
      {{ approval.supplement_date }}
    </td>
    <td class="px-3 py-1 truncate text-black" :title="approval.faa_approval_basis">
      {{ approval.faa_approval_basis }}
    </td>
    <td class="px-3 py-1">
      <button
        type="button"
        @click="toggleMoreInfo"
        class="text-indigo-600 hover:underline whitespace-nowrap"
      >
        {{ showMoreInfo ? "Hide" : "More" }}
      </button>
    </td>
  </tr>
  <tr v-if="showMoreInfo" class="bg-gray-50">
    <td colspan="5" class="px-3 py-2 border-t border-gray-100">
      <PMAMoreInfo :approval="approval"></PMAMoreInfo>
    </td>
  </tr>
</template>

<script setup>
import { defineProps, ref, watch } from "vue";
import PMAMoreInfo from "./PMAMoreInfo.vue";

// Linked-Company access lives on the company-level row now
// (PMACompanyRow.vue), opened by clicking the company name in the
// Linked Companies cell. This row stays per-PMA detail only.
const props = defineProps(["approval", "resetObject"]);

const showMoreInfo = ref(false);

watch(
  () => props.resetObject && props.resetObject.buttonHit,
  () => {
    showMoreInfo.value = false;
  }
);

function toggleMoreInfo() {
  showMoreInfo.value = !showMoreInfo.value;
}
</script>
